var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title:
          _vm.$t("CargoMsg.Cargo_View") +
          this.tabNumberTitle +
          _vm.$t("CargoMsg.Cargo_Config"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.closeHandler()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "20px" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-width": "70px", "label-position": "left" }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _vm.isBusinessTypeTab
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_BusinessType")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "custom-select-width",
                                  attrs: {
                                    filterable: "",
                                    multiple: "",
                                    placeholder: _vm.$t("Message.PleaseSelect")
                                  },
                                  model: {
                                    value: _vm.filter.businessTypes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "businessTypes", $$v)
                                    },
                                    expression: "filter.businessTypes"
                                  }
                                },
                                _vm._l(_vm.businessTypeList, function(item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticClass: "custom-select-width",
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Office_All,
                              "tag-name": "code",
                              "callback-method-type": "value",
                              clearable: "",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.filter.officeIds
                            },
                            on: {
                              parentCallBack: function(value) {
                                return (_vm.filter.officeIds = [].concat(value))
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  this.tabName === "MblNo"
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SystemMaintenance.RuleName")
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "custom-select-width",
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filter.ruleName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "ruleName", $$v)
                                  },
                                  expression: "filter.ruleName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  this.tabName === "MblNo"
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.DesignatedShippingLine"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticClass: "custom-select-width",
                                attrs: {
                                  no: "carrierId",
                                  clearable: "",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    companyLob: "seaExport",
                                    seaCmp: true,
                                    active: true
                                  },
                                  "callback-method-type": "value",
                                  multiple: true,
                                  "default-multiple-value":
                                    _vm.filter.carrierIds
                                },
                                on: {
                                  parentCallBack: function(value) {
                                    return (_vm.filter.carrierIds = [].concat(
                                      value
                                    ))
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  this.tabName === "BillNo"
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.BillOfLadingType"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.filter.billTypes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "billTypes", $$v)
                                    },
                                    expression: "filter.billTypes"
                                  }
                                },
                                _vm._l(
                                  _vm.SystemConstants.BILL_TYPE_SOURCE,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      staticClass: "custom-select-width",
                                      attrs: {
                                        label: item.chineseName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toQuery }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.reset }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "grid-params": _vm.girdParams,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "enable-col-resize": true
        },
        on: {
          "update:gridParams": function($event) {
            _vm.girdParams = $event
          },
          "update:grid-params": function($event) {
            _vm.girdParams = $event
          },
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }